import { PreQueryChannleProduct } from "@/model/preApplyResult";

export enum ApplyOrderStatus {
  SUBMITTING = "SUBMITTING", // 授信中
  SUCCEEDED = "SUCCEEDED", // 授信成功
  FAILED = "FAILED", // 授信拒绝
}

export interface BannerDataType {
  name: string;
  url: string;
  imageUrl: string;
}

export interface StateType {
  // 轮询引用
  timerId: NodeJS.Timer | null;
  // 参与额度申请的渠道列表以及结果
  applyData: PreQueryChannleProduct.Infomation | null;
  // 三方Banner配置
  bannerData: BannerDataType | null;
}

export enum AbtestEnum {
  CompareGroup = 1, // 对照组
  TestGroup = 2, // 实验组
}

export enum InsuranceEnum {
  HomeInsurancePick = "1", // 显示保险首页
  RejectInsurancePick = "2", // 领保险失败
  SuccessInsurancePick = "3", // 领保险成功
}

export enum PolicyStateEnum {
  SUCCESS = "SUCCESS",
  APPLY = "APPLY", // 提交
  FAIL = "FAIL",
}
